exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".redaction-search-result{display:flex;align-items:center;padding:12px;background-color:var(--component-background);border-radius:4px;box-shadow:0 0 3px var(--document-box-shadow);margin:8px 0}.redaction-search-result .Icon svg{transform:scale(1.2);padding-top:2px}.redaction-search-result .search-value{word-break:break-all;color:var(--secondary-button-text);font-weight:700}.redaction-search-result.active{background-color:var(--view-header-button-active)!important}.redaction-search-result-info{font-size:13px;color:var(--text-color)}", ""]);

// exports
